<template>
  <div class="li-fornecedor-proposta">
    <az-form>
      <div class="info-termo">
        <a @click="abrirModalTermo">
          <span>Licitante declarou-se Me/Epp/Mei: {{ propostaResumo.propostaTermo && propostaResumo.propostaTermo.microEmpresa === 'S' ? 'Sim' : 'Não' }}</span>
          Alterar
        </a>
      </div>
      <br/>

      <v-data-table
          :headers="headers"
          :items="licitacaoPropostaItens"
          :loading="false"
          class="az-table-list"
          sort-icon="mdi-menu-down"
          item-key="licitacaoLoteItemId"
          :rows-per-page-items="tablePaginationDropdown">
        <template slot="items" slot-scope="props">
          <licitacao-fornecedor-proposta-item v-model="props.item" @atualizarItemProposta="atualizarLoteItemProposta"/>
        </template>
      </v-data-table>
    </az-form>
    <div class="az-actions-form" v-if="!isPropostaEnviada">
      <div class="align-left"></div>
      <div class="align-right" style="display: flex">
        <a class="action-primary btn-salvar" @click="salvar">Salvar</a>
        <licitacao-fornecedor-acoes-enviar @atualizarProposta="atualizarProposta"
                                           v-if="!isPropostaEnviada && propostaResumo.podeEnviar"/>
      </div>
    </div>

    <licitacao-fornecedor-termos v-if="exibirModalTermo && isFornecedorAprovado"
                                 @concluido="finalizarAceiteTermos"
                                 @fechar="exibirModalTermo = false"/>

    <az-confirm @onConfirm="exibirModalInfoPropostaEnviada = false" @onDecline="exibirModalInfoPropostaEnviada = false"
                v-if="exibirModalInfoPropostaEnviada" :maxWidth=450 label-confirm="Ok" label-decline="Cancelar">
      Para alterar o a declaração é necessário cancelar o envio da proposta, após a alteração a proposta deve ser
      ENVIADA novamente.
    </az-confirm>
  </div>
</template>

<script>
import {actionTypes, exceptions, mutationTypes, tiposLicitacao} from '@/commons/constants'
import {mapActions, mapMutations, mapState} from 'vuex'
import accounting from 'accounting'
import _ from 'lodash'
import validadorFormulario from './credenciamento-fornecedor-proposta-validador'
import cabecalhoTabela from './credenciamento-fornecedor-proposta-cabecalho-tabela'
import CredenciamentoFornecedorPropostaItem from './CredenciamentoFornecedorPropostaItem.vue'
import CredenciamentoFornecedorAcoesEnviar from '../acoes/CredenciamentoFornecedorAcoesEnviar.vue'
import CredenciamentoFornecedorTermos from '../termos/CredenciamentoFornecedorTermos.vue'

export default {
  name: 'CredenciamentoFornecedorProposta',
  components: {
    CredenciamentoFornecedorPropostaItem,
    CredenciamentoFornecedorAcoesEnviar,
    CredenciamentoFornecedorTermos
  },
  data() {
    return {
      indiceHeaderValorReferencia: 6,
      licitacaoId: undefined,
      licitacaoPropostaItens: [],
      exibirModalTermo: false,
      exibirModalInfoPropostaEnviada: false,
      aguardarSalvamentoUnitario: false,
      aguardandoParaSalvarGeral: false
    }
  },
  computed: {
    headers() {
      const defaultHeaders = [].concat(cabecalhoTabela)
      if (this.licitacao.ehPerfilComprasBR) {
        defaultHeaders[1].text = 'Lote/Item'
      } else {
        defaultHeaders[1].text = 'Tipo'
      }
      const indiceHeaderValorReferencia = 7
      const indiceHeaderQuantidadeProposta = 6

      if (!this.ehAmparoLei14133Art82()) {
        defaultHeaders.splice(indiceHeaderQuantidadeProposta, 1)
      }

      if (this.isMenorPreco) {
        if (!this.licitacao.mostrarValorReserva) {
          defaultHeaders.splice(indiceHeaderValorReferencia, 1)
        }
      } else if (this.isMaiorDesconto) {
        let indiceHeaderValorUnitario = 7;
        let indiceHeaderValorTotal = 8;
        if (!this.licitacao.mostrarValorReserva) {
          defaultHeaders.splice(indiceHeaderValorReferencia, 1)
          indiceHeaderValorUnitario = 6;
          indiceHeaderValorTotal = 7;
        }

        defaultHeaders[indiceHeaderValorUnitario] = {
          text: 'Desconto (%)',
          align: 'right',
          sortable: false,
          width: '120px'
        }

        defaultHeaders.splice(indiceHeaderValorTotal, 1)

      } else if (this.isMaiorOferta) {
        let indiceHeaderValorUnitario = 7;
        let indiceHeaderValorTotal = 8;
        if (!this.licitacao.mostrarValorReserva) {
          defaultHeaders.splice(indiceHeaderValorReferencia, 1)
          indiceHeaderValorUnitario = 6;
          indiceHeaderValorTotal = 7;
        }

        defaultHeaders[indiceHeaderValorUnitario] = {
          text: 'Oferta ',
          align: 'center',
          sortable: false,
          width: '120px'
        }

        defaultHeaders.splice(indiceHeaderValorTotal, 1)
      }

      return defaultHeaders
    },
    isPropostaEnviada() {
      return this.propostaResumo.enviada
    },
    isMenorPreco() {
      return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MP
    },
    isMaiorDesconto() {
      return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MD
    },
    isMaiorOferta() {
      return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MO
    },
    isFornecedorAprovado() {
      return this.loki.user.domainId !== null
    },
    tablePaginationDropdown() {
      return [20, 30, 50]
    },
    ...mapState(['loki', 'licitacao', 'propostaResumo', 'termoAceiteProposta'])
  },
  beforeRouteLeave(to, from, next) {
    this.habilitarLoadingGlobal()
    this.resetUploadedFiles()
    next()
  },
  async mounted() {
    this.desabilitarLoadingGlobal()
    this.setLicitacaoId(this.$route.params.id)
    await this.buscarTodosItens()
  },
  methods: {
    finalizarAceiteTermos() {
      this.$emit('termosAceitos')
    },
    async atualizarProposta() {
      await this.buscarTodosItens()
    },
    atualizarObjetosItensProposta() {
      const novaListaItens = _.concat(this.licitacaoPropostaItens)
      this.licitacaoPropostaItens = []
      novaListaItens.forEach(item => this.licitacaoPropostaItens.push(_.clone(item)))
    },
    async buscarTodosItens() {
      this.setMensagemLoading('Carregando itens da licitação...')
      this.habilitarLoadingGlobal()
      this.licitacaoPropostaItens = await this.buscarLicitacaoPropostaItens(this.licitacaoId)
      this.carregarQuantidadeFornecedores()
      this.formatarPrecoItens()
      this.inserirInformacoesValidacao()
      this.desabilitarLoadingGlobal()
    },
    carregarQuantidadeFornecedores() {
      this.licitacaoPropostaItens.forEach(item => {
        if (this.ehAmparoLei14133Art82() && !this.esconderCamposProposta(item) && !item.quantidadeProposta) {
          item.quantidadeProposta = item.quantidade
        }
      })
    },
    esconderCamposProposta(item) {
      return this.isPropostaEnviada || (item.tipoNegociacao === 'Exclusivo' && !this.isFornecedorMicroEmpresa)
    },
    isFornecedorMicroEmpresa() {
      return this.termoAceiteProposta && this.termoAceiteProposta.microEmpresa === 'S'
    },
    formatarPrecoItens() {
      this.licitacaoPropostaItens.forEach(item => {
        if (item.preco) {
          item.preco = accounting.formatNumber(item.preco, item.casasDecimais, '.', ',')
        }
      })
    },
    inserirInformacoesValidacao() {
      this.licitacaoPropostaItens.forEach(item => {
        item.preenchido = validadorFormulario._isItemPreenchido(item)
        item.invalido = false
      })
    },
    montarPayload() {
      const payload = []
      this.licitacaoPropostaItens.forEach(licitacaoPropostaItem => {
        payload.push(Object.assign({}, licitacaoPropostaItem, {
          preco: (!this.isMenorPreco && (licitacaoPropostaItem.preco === null || licitacaoPropostaItem.preco.trim() === '')) ?
              null : accounting.unformat(licitacaoPropostaItem.preco, ',')
        }))
      })
      return payload
    },
    async salvar() {
      if (this.aguardarSalvamentoUnitario) {
        this.aguardandoParaSalvarGeral = true
        return
      }
      try {
        if (!validadorFormulario.validar(this.licitacaoPropostaItens, this.isMenorPreco, this.ehAmparoLei14133Art82())) {
          this.atualizarObjetosItensProposta()
          this.mostrarNotificacaoErro('Existem lotes com informações incompletas ou inválidas.')
          return
        }

        const payload = this.montarPayload()
        this.habilitarLoadingGlobal()

        this.setMensagemLoading('Salvando dados da proposta...')
        await this.atualizarPropostaItens({licitacaoId: this.licitacaoId, payload})
        this.mostrarNotificacaoSucessoDefault()
        await this.sincronizarProposta()
        await this.buscarTodosItens()
        this.desabilitarLoadingGlobal()
      } catch (e) {
        const exception = e.response ? exceptions[e.response.data.exception] : undefined
        if (exception && exception.ignorarNotificacaoDefault) {
          this.mostrarMensagemErro(e.response.data.message)
        }
        this.desabilitarLoadingGlobal()
      }
    },
    setLicitacaoId(licitacaoId) {
      this.licitacaoId = licitacaoId
    },
    async sincronizarProposta() {
      this.setMensagemLoading('Sincronizando proposta...')
      await this.buscarPropostaResumo(this.licitacaoId)
    },
    abrirModalTermo() {
      if (this.isPropostaEnviada) {
        this.exibirModalInfoPropostaEnviada = true
      } else {
        this.exibirModalTermo = true
      }
    },
    ehAmparoLei14133Art82() {
      return this.licitacao.amparoLegal && this.licitacao.amparoLegal.lei === 'Lei 14.133/2021, Art. 82, IV'
    },
    async atualizarLoteItemProposta(payload) {
      this.aguardarSalvamentoUnitario = true
      await this.atualizarItemProposta(payload);
      this.aguardarSalvamentoUnitario = false
    },
    ...mapActions([
      actionTypes.ATUALIZAR_PROPOSTA_ITENS,
      actionTypes.BUSCAR_LICITACAO_PROPOSTA_ITENS,
      actionTypes.BUSCAR_PROPOSTA_RESUMO,
      actionTypes.ATUALIZAR_ITEM_PROPOSTA
    ]),
    ...mapMutations([
      mutationTypes.MOSTRAR_MENSAGEM_ERRO
    ])
  },
  watch: {
    aguardarSalvamentoUnitario: {
      handler(novoValor) {
        if (novoValor === false && this.aguardandoParaSalvarGeral) {
          this.aguardandoParaSalvarGeral = false
          this.salvar()
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="stylus">

.li-fornecedor-proposta
  .btn-salvar
    height 36px
    text-transform uppercase
    padding 8px 15px !important
    margin 6px 8px

        .info-termo
            a
                text-decoration none
                position relative
                color #c6762b !important
                span
                    font-weight bold
                    color #808080
                    padding-right 15px


    @media (max-width: 450px)
        .li-fornecedor-proposta
            .az-table-list
                td:nth-of-type(1):before {
                    content "Lote/Item:"
                }
                td:nth-of-type(2):before {
                    content "Exclusivo:"
                }
                td:nth-of-type(3):before {
                    content "Descrição:"
                }
                td:nth-of-type(4):before {
                    content "Quantidade:"
                }
                td:nth-of-type(5):before {
                    content "Marca:"
                }
                td:nth-of-type(6):before {
                    content "Modelo:"
                }
                td:nth-of-type(7):before {
                    content "Val. Ref.:"
                }
                td:nth-of-type(8):before {
                    content "Val. Unit.:"
                }
                td:nth-of-type(9):before {
                    content "Val. Total:"
                }
                td:nth-of-type(10):before {
                    content "Anexos:"
                }

            .anexos
                .v-menu
                    display flex !important

            .az-table-list td
                text-align left !important
                padding 5px 10px !important

            .status
                span
                    color #777777
                    i
                        display none

    .status-active
      a
        text-decoration none
        position relative
        top -5px
        color #c6762b !important

        i
          position relative
          top 5px
          font-size 26px
          color #c6762b !important
          text-decoration none
</style>
